import { Injectable } from '@angular/core';

@Injectable()
export class HeaderService {
  displayNav: boolean = false;

  hideNav(): void {
    this.displayNav = false;
  }

  showNav(): void {
    this.displayNav = true;
  }
}
